// extracted by mini-css-extract-plugin
export default {"overdueLabel":"styles_overdueLabel__UxzyC","icon":"styles_icon__kPRL+","text":"styles_text__rqTKl"};